import React from "react";
import { NavigationIds } from "components/v2/shared-navigation/SharedNavigation";
import Tasks from "pages/dashboard/home/v2/tasks/Tasks";
import Documents from "pages/dashboard/v2/documents/Documents";
import Home from "pages/dashboard/v2/home/Home";
import LoanDetails from "pages/dashboard/home/v2/loan-details/LoanDetails";
import LoanDetailsMenu from "pages/dashboard/home/v2/loan-details-menu/LoanDetailsMenu";
import ProfileSettings from "pages/dashboard/v2/shared/profile-settings/ProfileSettings";
import { DashboardShellData } from "../dashboard-shell-content/types/dashboardShellData";

export interface DashboardTabContentProps {
  readonly activeTab: string;
  readonly showProfile: boolean;
  readonly dashboardData: DashboardShellData;
  readonly featureFlags?: { loanDetailsEnabled?: boolean };
  readonly pendingDocumentId: string | null;
  readonly onLoad: () => void;
  readonly onDocumentOpened: () => void;
  readonly isLoanDetailsLoading?: boolean;
  readonly loanDetailsLoadError?: boolean;
}

const DashboardTabContent: React.FC<DashboardTabContentProps> = ({
  activeTab,
  showProfile,
  dashboardData,
  featureFlags,
  pendingDocumentId,
  onLoad,
  onDocumentOpened,
  isLoanDetailsLoading = false,
  loanDetailsLoadError = false,
}) => {
  const {
    needsList,
    isNeedsListLoading,
    isNeedsListFetching,
    needsListError,
    refetchNeedsList,
    isCreatingNeeds,
  } = dashboardData;

  if (showProfile) {
    return <ProfileSettings />;
  }

  switch (activeTab) {
    case NavigationIds.Tasks:
      return (
        <Tasks
          onLoad={onLoad}
          isNeedsListLoading={isNeedsListLoading || isNeedsListFetching}
          isNeedsListFetching={isNeedsListFetching}
          isNeedsListError={needsListError}
          needsList={needsList}
          refetchNeedsList={refetchNeedsList}
        />
      );
    case NavigationIds.Docs:
      return (
        <Documents
          onLoad={onLoad}
          pendingDocumentId={pendingDocumentId}
          onDocumentOpened={onDocumentOpened}
        />
      );
    case NavigationIds.LoanDetails:
      if (featureFlags?.loanDetailsEnabled !== true) {
        return null;
      }
      return (
        <LoanDetails
          onLoad={onLoad}
          isLoanDetailsLoading={isLoanDetailsLoading}
          loanDetailsLoadError={loanDetailsLoadError}
        />
      );
    case NavigationIds.More:
      return featureFlags?.loanDetailsEnabled === true ? <LoanDetailsMenu onLoad={onLoad} /> : null;
    case NavigationIds.Home:
    default:
      return <Home onLoad={onLoad} isCreatingNeeds={isCreatingNeeds || isNeedsListLoading} />;
  }
};

export default DashboardTabContent;
